import React from "react"

export type SuggestedTerm = { label: string; url: string }

// Curated fallbacks shown when no "Popular searches" menu is configured in
// Shopify (Online Store -> Navigation). Elevated, on-brand categories rather
// than Searchspring's volume-ranked trending terms. Merchant-set menu links
// always take precedence over these.
const DEFAULT_SUGGESTED: SuggestedTerm[] = [
  { label: "Knitwear", url: "/search?query=knitwear" },
  { label: "Outerwear", url: "/search?query=outerwear" },
  { label: "New Arrivals", url: "/collections/new-arrivals" },
  { label: "Tailoring", url: "/search?query=tailoring" },
]

export function SearchDrawerSuggested({ terms }: { terms?: SuggestedTerm[] }) {
  const items = terms && terms.length > 0 ? terms : DEFAULT_SUGGESTED
  if (items.length === 0) return null

  return (
    <div className="search-drawer--menu-container">
      <h3 className="search-drawer--menu-title">Suggested</h3>
      <div className="search-drawer--suggested-items">
        {items.map((item) => (
          <a
            key={`${item.url}::${item.label}`}
            href={item.url}
            className="search-drawer--suggested-item"
          >
            {item.label.toLowerCase()}
          </a>
        ))}
      </div>
    </div>
  )
}
